export default __webpack_public_path__ + "static/media/Leggings of the Exorcist.ef4ce8a5.jpg";